import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_materials_inverted_trigonometry",
  "use": "lc_materials_inverted_trigonometry-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_materials_inverted_trigonometry\"><path d=\"M525.873548 897.156129l-383.174193-761.723871 763.045161-1.981935-379.870968 763.705806z\" p-id=\"3229\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol